import type { User } from 'firebase/auth';
import type { UserType } from 'src/auth/types';
import type { Account } from '@mattoespresso/brew-firestore';

import { doc, onSnapshot } from 'firebase/firestore';
import { signOut, onAuthStateChanged as onAuthStateChangedFB } from 'firebase/auth';

import { ROLES } from '../consts';
import { AUTH, FIRESTORE } from '../firebase';

export function onAuthStateChanged(callback: (user: UserType) => void): () => void {
  let unsubscribeAccount: (() => void) | null = null;

  const stopAccountListener = () => {
    if (unsubscribeAccount) {
      unsubscribeAccount();
      unsubscribeAccount = null;
    }
  };

  const unsubscribeAuth = onAuthStateChangedFB(AUTH, (user: User | null) => {
    stopAccountListener();

    if (!user) {
      callback(null);
      return;
    }

    const accountRef = doc(FIRESTORE, 'account', user.uid);

    unsubscribeAccount = onSnapshot(
      accountRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          signOut(AUTH).catch(console.error);
          return;
        }

        const account = snapshot.data() as Account;

        if (account.role && Object.values(ROLES).includes(account.role)) {
          callback({ ...user, ...account } as UserType);
        } else {
          signOut(AUTH).catch(console.error);
        }
      },
      (error) => {
        console.error(error);
        callback(null);
      }
    );
  });

  return () => {
    stopAccountListener();
    unsubscribeAuth();
  };
}
